import React from 'react';
import ReactPlayer from 'react-player/youtube';
import PdfIcon from '../../images/pdf.svg';

const PromoComponent = () => {
  return (
    <div className="promo-component">
      <div className="d-flex justify-content-around">
        <ReactPlayer url="https://www.youtube.com/watch?v=QCyBQNAqXCo&feature=emb_title&ab_channel=VMCCluster" />
        <div className="d-flex flex-column justify-content-around">
          <a
            href="/files/promo/EC+Enterprise+and+Industry+Fact+sheet+Serbia.pdf"
            download
          >
            <img
              alt="promo"
              style={{ width: '50px', height: '50px' }}
              src={PdfIcon}
            ></img>
            <h5>EC Enterprise and Industry Fact sheet Serbia</h5>
          </a>
          <a
            href="/files/promo/Doing-business-guide-2013-serbia+PWC.pdf"
            download
          >
            <img
              alt="promo"
              style={{ width: '50px', height: '50px' }}
              src={PdfIcon}
            ></img>
            <h5>Doing business guide 2013 serbia PWC</h5>
          </a>
          <a
            href="/files/promo/Doing+Business+in+Serbia+2013+SIEPA.pdf"
            download
          >
            <img
              alt="promo"
              style={{ width: '50px', height: '50px' }}
              src={PdfIcon}
            ></img>
            <h5>Doing Business in Serbia 2013 SIEPA</h5>
          </a>
          <a href="/files/promo/Doing+Business+in+Serbia+2015+WB.pdf" download>
            <img
              alt="promo"
              style={{ width: '50px', height: '50px' }}
              src={PdfIcon}
            ></img>
            <h5>Doing Business in Serbia 2015 WB</h5>
          </a>
        </div>
      </div>
    </div>
  );
};

export default PromoComponent;
